import React, {useState, useMemo} from 'react'
import PropTypes from 'prop-types'
import {UserAddOutlined} from '@ant-design/icons'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import ContactPerson from './ContactPerson'

import {
  ESTATE_SELLER_TYPE,
  ADDITIONAL_ESTATE_SELLER_TYPE,
  ESTATE_SELLERS_LIMIT,
} from 'lib/estateSellerConsts'

const EstateSellers = ({estateId, estateSellers}) => {
  const [newSeller, setNewSeller] = useState(null)

  const addEstateSeller = () => {
    setNewSeller({
      type: ADDITIONAL_ESTATE_SELLER_TYPE,
    })
  }

  const canAddAdditionalSeller = !newSeller && estateSellers.length < ESTATE_SELLERS_LIMIT

  const sortedSellers = useMemo(() => [
    ...estateSellers.filter(s => s.type === ESTATE_SELLER_TYPE),
    ...estateSellers.filter(s => s.type === ADDITIONAL_ESTATE_SELLER_TYPE),
  ], [estateSellers])

  return (
    <>
      <Heading level={3}>Kontaktperson</Heading>
      <div className="estate-sellers">
        {sortedSellers.map((seller) => (
          <ContactPerson
            key={seller.id}
            person={seller}
            estateId={estateId}
          />
        ))}
      </div>

      {newSeller && (
        <ContactPerson
          person={newSeller}
          estateId={estateId}
          onRemoveSeller={() => setNewSeller(null)}
          onSubmittedSeller={() => setNewSeller(null)}
        />
      )}

      {canAddAdditionalSeller && (
        <Button
          secondary
          type="action"
          icon={<UserAddOutlined />}
          onClick={addEstateSeller}
        >
          Legg til kontaktperson
        </Button>
      )}
    </>
  )
}

EstateSellers.propTypes = {
  estateSellers: PropTypes.array.isRequired,
  estateId: PropTypes.string.isRequired,
}

export default EstateSellers
